import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import FontAwesome from 'react-fontawesome';

import FontCustom from '../../../../components/Content/FontCustom';

import { capitalizeFirstLetter } from '../../../../util/text';

export default function CartProgress({ step, goToStep }) {
    const availableSteps = ['preview', 'shipping', 'payment'];

    const renderTitle = () => {
        return <FormattedMessage id={`cartStep${capitalizeFirstLetter(step)}Title`} defaultMessage={capitalizeFirstLetter(step)} />;
    };

    const renderInfoText = () => {
        return <FormattedHTMLMessage id={`cartStep${capitalizeFirstLetter(step)}InfoText`} defaultMessage="" />;
    };

    const getIconName = () => {
        switch(step) {
            case 'shipping':
                return 'address';

            case 'payment':
                return 'credit-card';

            case 'preview':
            default:
                return 'basket';
        }
    };

    const renderProgressIcon = (availableStep, index) => {
        if(step === availableStep) {
            return <span className="cart-step-icon bg-warning text-white"><FontCustom name={getIconName()} size="2.5" /></span>;
        } if(index < availableSteps.indexOf(step)) {
            return <span onClick={event => goToStep(availableStep)} className="cart-step-icon bg-primary text-white"><FontCustom name="check" size="2.5" /></span>;
        }
        return <FontAwesome name="circle" style={{ marginTop: '1.5rem' }} />;
    };

    if(availableSteps.includes(step)) {
        return (
            <div className="p-4 text-center">
                <h1 className="h3 my-3">{renderTitle()}</h1>
                <div className="mb-3 d-flex justify-content-center text-secondary">
                    {availableSteps.map((availableStep, index) => {
                        return (
                            <div key={availableStep} className={classnames(index < (availableSteps.length - 1) && ['cart-step-line'])}>
                                {renderProgressIcon(availableStep, index)}
                            </div>
                        );
                    })}
                </div>
                <span className="text-lg special-font text-dark" style={{ fontWeight: '300' }}>{renderInfoText()}</span>
            </div>
        );
    }
    return null;
}

CartProgress.propTypes = {
    step: PropTypes.string.isRequired,
    goToStep: PropTypes.func.isRequired,
};
